import React from "react";
import Page from "./Page";
import LebenslaufImage from "./niklaus-oberholzer_lebenslauf.jpg";

export default class LebenslaufPage extends React.Component {
  render() {
    return (
      <Page
        title="Lebenslauf"
        className="page__lebenslauf"
        headerImage={LebenslaufImage}
      >
        <img
          src={LebenslaufImage}
          className="page__article__image"
          alt="Niklaus Oberholzer Portrait"
        />
        <div role="article">
          <p>
            Niklaus Oberholzer schloss seine Studien 1978 mit dem Lizenziat und
            1983 mit dem Doktorat beider Rechte an der juristischen Fakultät der
            Universität Basel ab. Er erlangte 1981 das Patent als st. gallischer
            Rechtsanwalt und Notar.
          </p>
          <p>
            Er war zunächst als Gerichtsschreiber an st.  gallischen Gerichten
            tätig und wechselte dann als wissenschaftlicher Assistent für
            Privat- und Handelsrecht an die Universität St. Gallen. 1983 trat er
            die damals neu geschaffene Stelle eines Kantonalen
            Untersuchungsrichters für Schwer- und Bandenkriminalität bei der
            Staatsanwaltschaft St. Gallen an. Ab 1990 führte er in St. Gallen
            ein selbständiges Anwaltsbüro mit Schwergewicht Strafverteidigung.
            2000 wählte ihn der Kantonsrat zum Richter an das Kantonsgericht
            St. Gallen. Er präsidierte die Anklagekammer (strafprozessuale
            Beschwerdeinstanz) und die Anwaltskammer (Aufsichtsbehörde über die
            Rechtsanwältinnen und Rechtsanwälte) und war Mitglied der
            Familienrechtskammer. 2012 erfolgte die Wahl durch die
            Bundesversammlung zum Richter an das Schweizerische Bundesgericht in
            Lausanne. Er nahm dort Einsitz in der Strafrechtlichen Abteilung.
            2020 kehrte er in die Advokatur zurück und führt heute ein
            selbständiges Beratungsunternehmen für die Begleitung von Projekten,
            Erstellung von Gutachten und Durchführung von Untersuchungen.
          </p>
          <p>
            Neben seiner hauptberuflichen Tätigkeit war Niklaus Oberholzer von
            1987 bis 2010 stellvertretender Präsident einer Eidgenössischen
            Schätzungskommission. 2011 nahm er Einsitz in der Aufsichtsbehörde
            über die Bundesanwaltschaft, die er von 2015 bis 2018 präsidierte.
            In seiner militärischen Funktion war er von 1992 bis 2005 als
            Richter am Militärkassationsgericht tätig.
          </p>
          <p>
            Während annähernd 30 Jahren (1985 bis 2012) unterrichtete Niklaus
            Oberholzer im Rahmen der Anwaltsausbildung an der Universität
            St. Gallen das Fach Strafprozessrecht. Er hält regelmässig Referate
            und publiziert zu Themen der Kriminalpolitik sowie zu diversen
            Fragen des materiellen Strafrechts und des Verfahrensrechts. Sein
            Lehrbuch zu den Grundzügen des Strafprozessrechts ist in der
            Zwischenzeit in 5. Auflage erschienen.
          </p>
          <p>
            Niklaus Oberholzer ist Partner in der Anwaltskanzlei Zollinger
            Rechtsanwälte in Wetzikon und eingetragen im Anwaltsregister des
            Kantons Zürich. Er arbeitet als (beratender) Rechtsanwalt und als
            Gutachter im Bereich des Strafrechts und des Strafprozessrechts.
          </p>
        </div>
      </Page>
    );
  }
}
